import i18n from "123tcs-common/i18n";
import {
  getLanguageCodeFromStorage,
  setLanguageCodeToStorage,
} from "123tcs-common/utils/storage";
import PropTypes from "prop-types";
import React, { createContext, useContext, useMemo, useState } from "react";

const LanguageContext = createContext();
const supportedLanguages = {
  nl: "Nederlands",
  de: "Deutsch",
  en: "English",
  fr: "Français",
};

export function LanguageProvider({ children }) {
  // States
  const [languageCode, setLanguageCode] = useState(
    getLanguageCodeFromStorage() || "en",
  ); // default language is English

  // Functions
  const switchLanguage = (newLanguageCode) => {
    if (supportedLanguages[newLanguageCode]) {
      setLanguageCode(newLanguageCode);
      i18n.changeLanguage(newLanguageCode);
      setLanguageCodeToStorage(newLanguageCode);
    }
  };

  // Memos
  const getStates = useMemo(() => {
    return { languageCode, switchLanguage, supportedLanguages };
  }, [languageCode, switchLanguage, supportedLanguages]);

  // Render
  return (
    <LanguageContext.Provider value={getStates}>
      {children}
    </LanguageContext.Provider>
  );
}

LanguageProvider.propTypes = {
  children: PropTypes.element,
};

LanguageProvider.defaultProps = {
  children: null,
};

export const useLanguage = () => useContext(LanguageContext);
